import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AppDetailsApiService} from '../services/app-details-service/app-details-api.service';
import {BehaviorSubject, map} from 'rxjs';
import {UserService} from '../services/user-service/user.service';
import { PermissionsService } from 'src/app/pages/app-integrator-page/services/permissions.service';
import { NavigationSetup } from '../services/navigation-items-service/navigation-setup';

export const editAppGuard: CanActivateFn = (_route) => {
    const appDetailsService = inject(AppDetailsApiService);
    const permissionsService = inject(PermissionsService);
    const userService = inject(UserService);
    const router = inject(Router);
    const appId = _route.params['id'];

    if(Number.isNaN(Number(appId))) {
      console.error('Can not fetch app details, invalid id: ', appId);
      return router.createUrlTree([NavigationSetup.NOT_FOUND.path]);
    }
  
    return appDetailsService.getAppDetails(appId).pipe(
      map((_appDetails) => {
        if (permissionsService.canEditApp(userService.getUser(), _appDetails)) {
          appDetailsService.appDetails = new BehaviorSubject(_appDetails);
          return true;
        }
        return router.createUrlTree([NavigationSetup.START_PAGE.path]);
      }),
    );
};
